const computedense = (width) => {
  return window.innerWidth < 550 || width < 550 ? "ultra" : (window.innerWidth < 950 || width < 950 ? "dense" : "normal");
}

export default computedense;
